/**
 * Loading state
 */
export var Loading;
(function (Loading) {
    Loading["LOADING"] = "LOADING";
    Loading["LOADED"] = "LOADED";
})(Loading || (Loading = {}));
/**
 * Returns loading's classname depending on loading type
 * @param loadingType {string} - Loading type
 * @returns {string} - Loading value
 */
export var getLoadingClassName = function (loadingType) {
    switch (loadingType) {
        case 'LOADING':
            return 'loading';
        case 'LOADED':
            return 'loaded';
        default:
            return '';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGFibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9vYmplY3RzL2ZhY2V0cy9Mb2FkYWJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLE9BR1g7QUFIRCxXQUFZLE9BQU87SUFDakIsOEJBQW1CLENBQUE7SUFDbkIsNEJBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUhXLE9BQU8sS0FBUCxPQUFPLFFBR2xCO0FBV0Q7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLG1CQUFtQixHQUFHLFVBQUMsV0FBb0I7SUFDdEQsUUFBUSxXQUFXLEVBQUU7UUFDbkIsS0FBSyxTQUFTO1lBQ1osT0FBTyxTQUFTLENBQUE7UUFDbEIsS0FBSyxRQUFRO1lBQ1gsT0FBTyxRQUFRLENBQUE7UUFDakI7WUFDRSxPQUFPLEVBQUUsQ0FBQTtLQUNaO0FBQ0gsQ0FBQyxDQUFBIn0=